import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuComponent } from './menu/menu.component';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { TreeComponent } from './tree/tree.component';



@NgModule({
  declarations: [MenuComponent,TreeComponent],
  exports:[MenuComponent,TreeComponent],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,RouterModule
  ]
})
export class ComponentsModule { }
